import React from "react";

export function Input({ label, value, onChange, type = "text", testid }) {
  return (
    <div>
      <label className="text-sm font-medium text-[#5C635E] mb-1.5 block">{label}</label>
      <input
        data-testid={testid}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-[#FDFBF7] border border-[#EAE6DF] rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-[#4A5D4E]/20 focus:border-[#4A5D4E]"
      />
    </div>
  );
}
